import { datadogRum } from '@datadog/browser-rum'
// This should be activated after updating to react 18 or higher
// import { reactPlugin } from '@datadog/browser-rum-react'

export function initDatadog() {
  if (import.meta.env.PROD) {
    datadogRum.init({
      applicationId: 'cb7f767b-0825-4eaa-92dd-a5470af118b9',
      clientToken: 'pub3efba1ad13ea18edcf5d66bfc224379a',
      site: 'datadoghq.eu',
      service: 'spine-frontend',
      env: import.meta.env.MODE,
      version: import.meta.env.VITE_COMMIT_SHA,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      defaultPrivacyLevel: 'mask-user-input'
      //plugins: [reactPlugin({ router: true })],
    })
  }
}
